import 'whatwg-fetch';
import 'url-search-params-polyfill';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// SheerID stuff
import { setOptions, overrideComponent, setMetadata } from '@sheerid/jslib';
import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { StepSuccessComponent } from './components/steps/StepSuccessComponent';
import { StepStudentPersonalInfoComponent } from './components/steps/StepStudentPersonalInfoComponent';
import { getQueryParamsByName } from './lib/utils/browser';

setOptions(defaultOptions);
googleTagManagerHook();

const utm_campaign = getQueryParamsByName('utm_campaign') || '';
const utm_medium = getQueryParamsByName('utm_medium') || '';
const refererID = getQueryParamsByName('refererID') || '';
const utm_source = getQueryParamsByName('utm_source') || '';
const refererUrl = getQueryParamsByName('refererUrl') || '';

setMetadata({
    communicationOptIn : true,
    utm_campaign,
    utm_medium,
    refererID,
    utm_source,
    refererUrl,
});

// @ts-ignore
overrideComponent('StepStudentPersonalInfoComponent', StepStudentPersonalInfoComponent);
// @ts-ignore
overrideComponent('StepSuccessComponent', StepSuccessComponent);

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();
